import { DefaultService } from '@/services/DefaultService';

export default class AparelhoJupiterService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(id, page = 0,order,column,limit = 50,situacao=2, ...param) {
        return this._http.get(encodeURI(`${this._env}/mobile-jupiter/${id}.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findActive(id, order,column) {
        return this._http.get(encodeURI(`${this._env}/mobile-jupiter/active/${id}.json?column=${column}&order=${order}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAparelhos(obj) {
        return this._http.post(`${this._env}/mobile-jupiter/updatesituacao/aparelhos`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}